import React, { useRef, useState } from 'react';

import moment from 'moment-timezone';
import { WidgetViewMode } from 'utilitys/reporting/widgetViewModeUtils';

import { useUpdateIfReady } from 'components/Dashboards/Reporting/widgetInReport/hooks/RefreshWidgetPayload/useUpdateIfReady';
import { UseTimelineAndDensityProvider } from 'components/widgets/timelineAndDensity/TimelineAndDensity.provider';

interface Props {
    api: UseTimelineAndDensityProvider['api'];
    widgetViewMode: WidgetViewMode;
    setIsPayloadReady?: (newValue: boolean) => void;
}

export const useTimelineAndDensityLogic = ({ widgetViewMode, setIsPayloadReady, api }: Props) => {
    const [isShowDensity, setIsShowDensity] = useState<boolean>(true);
    const todayLineRef = useRef<HTMLDivElement | null>(null);
    const mapContainerRef = useRef<HTMLDivElement | null>(null);
    useUpdateIfReady({ isPayloadReadyCallback: isPayloadReady, widgetViewMode: widgetViewMode });
    const todayLineDate = moment().valueOf();

    const setTodayLine = (position: number | null) => {
        if (typeof position === 'number' && todayLineRef.current && mapContainerRef.current) {
            todayLineRef.current.style.left = `${position}px`;
            todayLineRef.current.style.height = `${mapContainerRef.current.offsetHeight - 60}px`;
            todayLineRef.current.style.display = 'block';
        }
    };

    function isPayloadReady() {
        const currentPayload = api.getTimelineAndDensity.payload;
        if (!currentPayload) return;
        if (currentPayload.filter.filters === undefined) return;
        setIsPayloadReady && setIsPayloadReady(true);
    }

    const handleShowDensity = (event: React.ChangeEvent<HTMLInputElement>) => {
        const isChecked = event.target.checked;
        setIsShowDensity(isChecked);
    };
    return {
        logic: {
            mapContainerRef,
            todayLineRef,
            isShowDensity,
            handleShowDensity,
            todayLineDate,
            setTodayLine,
        },
    };
};
